exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear[data-v-542fb4da] {\n  text-align: justify;\n}\n.h2_title[data-v-542fb4da] {\n  font-weight: normal;\n}\n", ""]);

// exports
